import StyledLink from '../../Link/Link.mjs';
import styled from 'styled-components';

const StyledList = styled.ul `
  display: grid;
  margin-top: 0;
  padding-left: 0;
  gap: ${props => (props.withIcon ? '1rem' : '0.5rem')};
  color: ${props => props.theme.colors.textColor};
`;
const StyledListItem = styled.li `
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  ${StyledLink} {
    font-size: ${props => props.theme.typography.text.small.fontSize};
    align-items: center;
  }

  svg {
    height: 100%;
    width: 0.875rem;
    margin-bottom: 1px;
    margin-right: 1px;
  }
`;

export { StyledList, StyledListItem };
//# sourceMappingURL=VerticalList.styles.mjs.map
